import React, { Component } from 'react'
import QuestionDisclaimer from '../templates/QuestionDisclaimer'
import RedirectMacros from '../templates/RedirectMacros'

class RedirectInstant extends Component {
    state = {}

    render() {
        let { question, disclaimer, disclaimerRequired, placeholder, order, questionId, callToAction, negCallToAction } = this.props.data

        return (
            <div>
                <div className="text-center text-secondary mb-2">Q{order}: Redirect Instant</div>
                <h3>
                    <textarea maxLength={600} cols="50" className="form-control d-inline-block" type="text" defaultValue={question} size="100" onChange={this.props.handleChange(questionId)}></textarea>
                </h3>
                <div className="mt-3 mb-3">
                    <input className="form-control" type="text" defaultValue={placeholder} placeholder="Add URL Here." onChange={this.props.handleChangePlaceholder(questionId)} />
                </div>
                <RedirectMacros />
            </div>
        )
    }
}

export default RedirectInstant
